module.exports = __webpack_public_path__ + "img/rejected.61778fa7.svg";